export const baseUrl =
    process.env.REACT_APP_NODE_ENV === 'production'
        ? process.env.REACT_APP_PRODUCTION_SERVER
        : process.env.REACT_APP_DEVELOPMENT_SERVER

export const baseStripeUrl =
    process.env.REACT_APP_NODE_ENV === 'production'
        ? process.env.REACT_APP_STRIPE_PRODUCTION_SERVER
        : process.env.REACT_APP_STRIPE_DEVELOPMENT_SERVER
